"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardLayoutSectionHeaderRenderer = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2022 GoodData Corporation
var React = tslib_1.__importStar(require("react"));
var DashboardLayoutItemViewRenderer_1 = require("./DashboardLayoutItemViewRenderer");
var DashboardLayoutSectionHeader_1 = require("./DashboardLayoutSectionHeader");
var emptyFacade_1 = require("./utils/emptyFacade");
function DashboardLayoutSectionHeaderRenderer(props) {
    var section = props.section, screen = props.screen;
    var sectionHeader = section.header();
    return sectionHeader ? (React.createElement(DashboardLayoutItemViewRenderer_1.DashboardLayoutItemViewRenderer, { DefaultItemRenderer: DashboardLayoutItemViewRenderer_1.DashboardLayoutItemViewRenderer, item: emptyFacade_1.emptyItemFacadeWithFullSize, screen: screen },
        React.createElement(DashboardLayoutSectionHeader_1.DashboardLayoutSectionHeader, { title: sectionHeader.title, description: sectionHeader.description }))) : null;
}
exports.DashboardLayoutSectionHeaderRenderer = DashboardLayoutSectionHeaderRenderer;
//# sourceMappingURL=DashboardLayoutSectionHeaderRenderer.js.map